import React, { FC } from 'react'
import Select from 'react-select'
import { UnknownQuestionTableRowSelectProps } from './types'
import SelectorStyles from '../../../constants/selectorStyles'
import { useUnknownQuestionsOptions } from './hooks'
import { unansweredQuestionTypeLabels } from 'tabs/nlp/components/unansweredQuestions/configs'
import { Option } from 'helpers/selects'

export const UnknownQuestionTableRowSelect: FC<UnknownQuestionTableRowSelectProps> = ({
                                                                                        onValueChange,
                                                                                        questionTypes,
                                                                                        question,
                                                                                      }) => {
  const { currentOption, updateValue } = useUnknownQuestionsOptions(question)

  const onSelectValueChange = ({ value }) => {
    updateValue(value)
    onValueChange(value)
  }


  const questionTypeLabels: Option[] = questionTypes.map((value) => {
    const label = unansweredQuestionTypeLabels[value] || value
    return ({ value, label })
  })

  return (
    <Select
      styles={SelectorStyles}
      options={questionTypeLabels}
      value={currentOption as any}
      onChange={onSelectValueChange}
      placeholder="Select question type"
    />
  )
}
